import { useEffect } from 'react';
import { JobSearch } from '@/components/partial/job-search';
import { useUpdateUserJobs } from '@/data/account/user-jobs';
import { ProfileStepIds } from '@/models/recommendation';
import { JobType, type JobTitle } from '@/models/taxonomy/job';
import { BaseQuestion } from '@/packages/profile-quiz/components/questions/base-question';
import { useProfileQuiz } from '@/packages/profile-quiz/context/profile-quiz';
import type { QuestionProps } from '@/packages/profile-quiz/context/profile-quiz/types';
import { ProfileFields } from '@/packages/profile-quiz/context/profile-quiz/types';

export const DesiredJobStep = (_props: QuestionProps) => {
  const { answers, setQuizAnswer, setCurrentStepValid } = useProfileQuiz();
  const { mutate: updateUserJobs } = useUpdateUserJobs();
  const processedResponseText =
    'Boa meta! Esse objetivo já me ajuda a entender melhor onde você quer chegar.';
  const questionText =
    '🚀 Pensando no seu próximo passo, qual cargo você gostaria de alcançar?';

  const setCurrentJob = (value: JobTitle | null) => {
    if (value?.id) {
      setQuizAnswer(ProfileFields.DesiredJob, {
        id: value.id,
        name: value.name,
        occupation_id: value.occupation_id,
      });
      updateUserJobs({
        title_id: value.id,
        job_type: JobType.Desired,
      });

      setCurrentStepValid(true);
    }
  };

  useEffect(() => {
    const isValid =
      answers.desired_job !== null &&
      (answers.desired_job?.name?.trim().length ?? 0) > 0;
    setCurrentStepValid(isValid);
  }, [answers.desired_job, setCurrentStepValid]);

  return (
    <BaseQuestion
      questionTitle={questionText}
      questionId={ProfileStepIds.DesiredJob}
      processedResponseText={processedResponseText}
    >
      <JobSearch
        jobTitle={answers.desired_job ?? null}
        onSelect={setCurrentJob}
      />
    </BaseQuestion>
  );
};
